export default "// babel.config.js\n\nmodule.exports = {\n  presets: ['@babel/preset-env']\n}\n";